export enum CompareRangeType {
    //Date to date
    lastYearDateToDate = "lastYearDateToDate",
    fourPreviousWeeksDateToDate = "fourPreviousWeeksDateToDate",
    threePreviousMonthsDateToDate = "threePreviousMonthsDateToDate",
    twelvePreviousMonthsDateToDate = "twelvePreviousMonthsDateToDate",

    monthLastYearDateToDate = "monthLastYearDateToDate",
    thirtyPreviousDaysDateToDate = "thirtyPreviousDaysDateToDate",
    fifteenPreviousDaysDateToDate = "fifteenPreviousDaysDateToDate",
    previousMonthDateToDate = "previousMonthDateToDate",
    previousMonthSameDayDateToDate = "previousMonthSameDayDateToDate",
    weekLastYearDateToDate = "weekLastYearDateToDate",
    dayLastYearDateToDate = "dayLastYearDateToDate",
    sameDaysLastYearDateToDate = "sameDaysLastYearDateToDate",
    selectionDateToDate = "selectionDateToDate",

    //tantamount
    selectionTantamount = "selectionTantamount",
    lastYearTantamount = "lastYearTantamount",
    thirtyPreviousDaysTantamount = "thirtyPreviousDaysTantamount",
    fifteenPreviousDaysTantamount = "fifteenPreviousDaysTantamount",
    previousMonthTantamount = "previousMonthTantamount",
    weekLastYearTantamount = "weekLastYearTantamount",
    dayLastYearTantamount = "dayLastYearTantamount",
    sameDaysLastYearTantamount = "sameDaysLastYearTantamount",
    monthLastYearTantamount = "monthLastYearTantamount",
    threePreviousMonthsTantamount = "threePreviousMonthsTantamount",
    twelvePreviousMonthsTantamount = "twelvePreviousMonthsTantamount",

    // other
    lastFourWeeks = "lastFourWeeks",
    lastFourWeeksSameDay = "lastFourWeeksSameDay",
    lastWeek = "lastWeek",
    previousWeek = "previousWeek",
    previousWeekSameDay = "previousWeekSameDay",
    previousDay = "previousDay",
    yesterday = "yesterday",
    lastTwoWeeks = "lastTwoWeeks",
    forceSelection = "forceSelection",
}
